import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { type ClassesType, Text, type TextProps } from '@pbt/pbt-ui-components'
import { Eye as EyeIcon } from '@pbt/pbt-ui-components/src/icons'

const useStyles = makeStyles(
  () => ({
    icon: {
      verticalAlign: 'middle',
    },
  }),
  { name: 'PreviewButton' },
)

export interface PreviewButtonProps extends TextProps {
  classes?: ClassesType<typeof useStyles>
  disabled?: boolean
  label?: string
  onClick: () => void
}

const PreviewButton = ({
  classes: classesProp,
  onClick,
  disabled = false,
  label,
  ...rest
}: PreviewButtonProps) => {
  const classes = useStyles({ classes: classesProp })
  const { t } = useTranslation('Common')

  return (
    <Text
      link
      disabled={disabled}
      onClick={() => !disabled && onClick()}
      {...rest}
    >
      <EyeIcon className={classes.icon} />
      {label || t('Common:PREVIEW_ACTION')}
    </Text>
  )
}

export default PreviewButton
